<template>
  <BaseDialog
    v-model="showDialog"
    dialogIcon="mdi-account-cancel"
    title="Deaktivert"
    subtitle="Bruker har blitt deaktivert"
  >
    <template v-slot>
      <p>
        Bruker har blitt deaktivert og du har blitt satt som ansvarlig på
        følgende
      </p>
      <span v-if="actions && actions.length > 0">
        <v-subheader>Tiltak</v-subheader>
        <v-list
          class="py-0"
          v-for="(action, index) in actions"
          :key="index + 'action'"
          color="cardSurface"
        >
          <v-list-item @click="goTo('Measure', action.id)" two-line>
            <v-list-item-content>
              <v-list-item-title>{{ action.title }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ action.projAberration.project.name }} -
                {{ action.aberrationActionStatus }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </span>
      <span v-if="regLines && regLines.length > 0">
        <v-subheader>Reklamasjon</v-subheader>
        <v-list
          class="py-0"
          v-for="(regLine, index) in regLines"
          :key="index + 'regLine'"
          color="cardSurface"
        >
          <v-list-item @click="goTo('Complaint', regLine.id)" two-line>
            <v-list-item-content>
              <v-list-item-title>{{ regLine.name }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ regLine.projRegistrationProjectName }} -
                {{ regLine.regStatus }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </span>
      <span v-if="inquiryRegLines && inquiryRegLines.length > 0">
        <v-subheader>Hendvendelse</v-subheader>
        <v-list
          class="py-0"
          v-for="(regLine, index) in inquiryRegLines"
          :key="index"
          color="cardSurface"
        >
          <v-list-item @click="goTo('Complaint', regLine.id)" two-line>
            <v-list-item-content>
              <v-list-item-title>{{ regLine.name }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ regLine.projRegistrationProjectName }} -
                {{ regLine.regStatus }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </span>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    reglines: {
      type: Array,
    },
    actions: {
      type: Array,
    },
  },
  methods: {
    goTo(route, param) {
      this.$router.push({ name: route, params: { id: param } });
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    regLines(): Array<any> {
      if (this.reglines) {
        return (this as any).reglines.filter((x) => !x.isInquiry);
      }
      return [];
    },
    inquiryRegLines(): Array<any> {
      if (this.reglines) {
        return (this as any).reglines.filter((x) => x.isInquiry);
      }
      return [];
    },
  },

  components: {
    BaseDialog,
  },
});
</script>
